/**
 * Please note:
 *
 * Translations are provided as an illustration only and are
 * not guaranteed to be accurate or error-free.
 *
 * They are designed to show developers where to store their
 * chosen phrase or spelling variant in the target language.
 */

export const AG_CHARTS_LOCALE_EL_GR: Record<string, string> = {
    ariaAnnounceChart: 'διάγραμμα, ${seriesCount}[number] σειρές',
    ariaAnnounceFlowProportionLink: 'σύνδεσμος ${index} από ${count}, από ${from} προς ${to}, ${sizeName} ${size}',
    ariaAnnounceFlowProportionNode: 'κόμβος ${index} από ${count}, ${description}',
    ariaAnnounceGaugeChart: 'διάγραμμα δείκτη, ${caption}',
    ariaAnnounceHierarchyChart: 'διάγραμμα ιεραρχίας, ${caption}',
    ariaAnnounceHierarchyDatum: 'επίπεδο ${level}[number], ${count}[number] παιδιά, ${description}',
    ariaAnnounceHoverDatum: '${datum}',
    ariaDescriptionLegendItem: 'Πατήστε Space ή Enter για εναλλαγή ορατότητας',
    ariaLabelAddHorizontalLine: 'Προσθήκη Οριζόντιας Γραμμής',
    ariaLabelAnnotationOptionsToolbar: 'Επιλογές σχολιασμού',
    ariaLabelAnnotationSettingsDialog: 'Ρυθμίσεις Σχολιασμού',
    ariaLabelColorPicker: 'Επιλογή χρώματος',
    ariaLabelFinancialCharts: 'Χρηματοοικονομικά γραφήματα',
    ariaLabelLegend: 'Υπόμνημα',
    ariaLabelLegendItem: '${label}, Στοιχείο υπόμνημα ${index}[number] από ${count}[number]',
    ariaLabelLegendItemUnknown: 'Άγνωστο στοιχείο υπόμνημα',
    ariaLabelLegendPageNext: 'Επόμενη Σελίδα Θρύλου',
    ariaLabelLegendPagePrevious: 'Προηγούμενη Σελίδα Θρύλου',
    ariaLabelLegendPagination: 'Σελιδοποίηση Υπόμνημα',
    ariaLabelNavigator: 'Πλοηγός',
    ariaLabelNavigatorMaximum: 'Μέγιστο',
    ariaLabelNavigatorMinimum: 'Ελάχιστο',
    ariaLabelNavigatorRange: 'Εύρος',
    ariaLabelRangesToolbar: 'Εύρη',
    ariaLabelSettingsTabBar: 'Ρυθμίσεις',
    ariaLabelZoomToolbar: 'Ζουμ',
    ariaValuePanRange: '${min}[percent0to2dp] έως ${max}[percent0to2dp]',
    contextMenuDownload: 'Λήψη',
    contextMenuPanToCursor: 'Μετακίνηση εδώ',
    contextMenuToggleOtherSeries: 'Εναλλαγή άλλων σειρών',
    contextMenuToggleSeriesVisibility: 'Εναλλαγή Ορατότητας',
    contextMenuZoomToCursor: 'Ζουμ εδώ',
    dialogHeaderChannel: 'Κανάλι',
    dialogHeaderDatePriceRange: 'Ημερομηνία και Τιμή',
    dialogHeaderDateRange: 'Εύρος ημερομηνιών',
    dialogHeaderFibonacciRange: 'Επίπεδα Fibonacci',
    dialogHeaderLine: 'Γραμμή',
    dialogHeaderPriceRange: 'Εύρος Τιμών',
    dialogHeaderText: 'Κείμενο',
    dialogInputAlign: 'Ευθυγράμμιση',
    dialogInputColorPicker: 'Χρώμα',
    dialogInputColorPickerAltText: 'Χρώμα Κειμένου',
    dialogInputExtendAbove: 'Επέκταση πάνω',
    dialogInputExtendBelow: 'Επέκταση προς τα κάτω',
    dialogInputExtendChannelEnd: 'Επέκταση τέλους καναλιού',
    dialogInputExtendChannelStart: 'Επέκταση έναρξης καναλιού',
    dialogInputExtendLeft: 'Επέκταση προς τα αριστερά',
    dialogInputExtendLineEnd: 'Επέκταση άκρης γραμμής',
    dialogInputExtendLineStart: 'Επέκταση έναρξης γραμμής',
    dialogInputExtendRight: 'Επέκταση δεξιά',
    dialogInputFibonacciBands: 'Ζώνες',
    dialogInputFibonacciBandsAltText: 'Ζώνες Fibonacci',
    dialogInputFillColorPicker: 'Γέμισμα',
    dialogInputFillColorPickerAltText: 'Χρώμα Συμπλήρωσης',
    dialogInputFontSize: 'Μέγεθος',
    dialogInputFontSizeAltText: 'Μέγεθος γραμματοσειράς',
    dialogInputLineStyle: 'Παύλα',
    dialogInputPosition: 'Θέση',
    dialogInputReverse: 'Αντίστροφα',
    dialogInputShowFill: 'Εμφάνιση Γέμισης',
    dialogInputStrokeWidth: 'Βάρος',
    dialogInputStrokeWidthAltText: 'Πάχος γραμμής',
    iconAltTextAlignCenter: 'Κέντρο',
    iconAltTextAlignLeft: 'Αριστερά',
    iconAltTextAlignRight: 'Δεξιά',
    iconAltTextClose: 'Κλείσιμο',
    iconAltTextLineStyleDashed: 'Μακρά-παύλα',
    iconAltTextLineStyleDotted: 'Μικρή παύλα',
    iconAltTextLineStyleSolid: 'Συμπαγές',
    iconAltTextPositionBottom: 'Κάτω',
    iconAltTextPositionCenter: 'Κέντρο',
    iconAltTextPositionTop: 'Κορυφή',
    inputTextareaPlaceholder: 'Προσθήκη Κειμένου',
    measurerDateRangeBars: '${value}[number] μπάρες',
    measurerPriceRangePercent: '${value}[percent]',
    measurerPriceRangeValue: '${value}[number]',
    measurerVolume: 'Όγο ${value}',
    overlayLoadingData: 'Φόρτωση δεδομένων...',
    overlayNoData: 'Δεν υπάρχουν δεδομένα για εμφάνιση',
    overlayNoVisibleSeries: 'Δεν υπάρχει ορατή σειρά',
    overlayUnsupportedBrowser:
        'Μη συμβατή έκδοση προγράμματος περιήγησης. Παρακαλώ αναβαθμίστε το πρόγραμμα περιήγησής σας.',
    seriesHistogramTooltipCount: '${yName} (πλήθος)',
    seriesHistogramTooltipFrequency: 'Συχνότητα',
    seriesHistogramTooltipMean: '${yName} (μέσος όρος)',
    seriesHistogramTooltipSum: '${yName} (άθροισμα)',
    toolbarAnnotationsArrow: 'Βέλος',
    toolbarAnnotationsArrowDown: 'Βέλος Κάτω',
    toolbarAnnotationsArrowUp: 'Βέλος Πάνω',
    toolbarAnnotationsCallout: 'Επισημείωση',
    toolbarAnnotationsClearAll: 'Καθαρισμός Όλων',
    toolbarAnnotationsComment: 'Σχόλιο',
    toolbarAnnotationsDatePriceRange: 'Ημερομηνία και Τιμή',
    toolbarAnnotationsDateRange: 'Εύρος Ημερομηνιών',
    toolbarAnnotationsDelete: 'Διαγραφή',
    toolbarAnnotationsDisjointChannel: 'Αποσυνδεδεμένο Κανάλι',
    toolbarAnnotationsDragHandle: 'Σύρετε τη Γραμμή Εργαλείων',
    toolbarAnnotationsFibonacciAnnotations: 'Φιμπονάτσι',
    toolbarAnnotationsFibonacciRetracement: 'Επιστροφή Φιμπονάτσι',
    toolbarAnnotationsFibonacciRetracementTrendBased: 'Νέα Βάση Τάσης Φίμπονατσι',
    toolbarAnnotationsFillColor: 'Χρώμα Γέμισης',
    toolbarAnnotationsHorizontalLine: 'Οριζόντια Γραμμή',
    toolbarAnnotationsLineAnnotations: 'Γραμμές Τάσης',
    toolbarAnnotationsLineColor: 'Χρώμα Γραμμής',
    toolbarAnnotationsLineStrokeWidth: 'Πλάτος Γραμμής Διαδρομής',
    toolbarAnnotationsLineStyle: 'Στυλ Γραμμής',
    toolbarAnnotationsLock: 'Κλείδωμα',
    toolbarAnnotationsMeasurerAnnotations: 'Μέτρα',
    toolbarAnnotationsNote: 'Σημείωση',
    toolbarAnnotationsParallelChannel: 'Παράλληλο Κανάλι',
    toolbarAnnotationsPriceRange: 'Εύρος Τιμών',
    toolbarAnnotationsQuickDatePriceRange: 'Μετρήστε',
    toolbarAnnotationsSettings: 'Ρυθμίσεις',
    toolbarAnnotationsShapeAnnotations: 'Βέλη',
    toolbarAnnotationsText: 'Κείμενο',
    toolbarAnnotationsTextAnnotations: 'Κείμενο Σχολίων',
    toolbarAnnotationsTextColor: 'Χρώμα Κειμένου',
    toolbarAnnotationsTextSize: 'Μέγεθος Κειμένου',
    toolbarAnnotationsTrendLine: 'Γραμμή Τάσης',
    toolbarAnnotationsUnlock: 'Ξεκλείδωμα',
    toolbarAnnotationsVerticalLine: 'Κάθετη Γραμμή',
    toolbarRange1Month: '1Μ',
    toolbarRange1MonthAria: '1 μήνας',
    toolbarRange1Year: '1Έτος',
    toolbarRange1YearAria: '1 έτος',
    toolbarRange3Months: '3Μ',
    toolbarRange3MonthsAria: '3 μήνες',
    toolbarRange6Months: '6Μή',
    toolbarRange6MonthsAria: '6 μήνες',
    toolbarRangeAll: 'Όλα',
    toolbarRangeAllAria: 'Όλα',
    toolbarRangeYearToDate: 'Έτος έως σήμερα',
    toolbarRangeYearToDateAria: 'Έτος μέχρι σήμερα',
    toolbarSeriesTypeCandles: 'Κηροπήγια',
    toolbarSeriesTypeDropdown: 'Τύπος Διαγράμματος',
    toolbarSeriesTypeHighLow: 'Υψηλό Χαμηλό',
    toolbarSeriesTypeHLC: 'ΥΨΧ',
    toolbarSeriesTypeHollowCandles: 'Κεριά Hollow',
    toolbarSeriesTypeLine: 'Γραμμή',
    toolbarSeriesTypeLineWithMarkers: 'Γραμμή με Δείκτες',
    toolbarSeriesTypeOHLC: 'OHLC',
    toolbarSeriesTypeStepLine: 'Βηματική Γραμμή',
    toolbarZoomPanEnd: 'Μετακίνηση στο τέλος',
    toolbarZoomPanLeft: 'Μετατόπιση αριστερά',
    toolbarZoomPanRight: 'Μετατόπιση δεξιά',
    toolbarZoomPanStart: 'Μετακίνηση στην αρχή',
    toolbarZoomReset: 'Επαναφορά της εστίασης',
    toolbarZoomZoomIn: 'Μεγέθυνση',
    toolbarZoomZoomOut: 'Σμίκρυνση',
    tooltipPaginationStatus: '${index}[number] από ${count}[number]',
};
